<template>
<div style="width:1300px;margin:0 auto;padding:30px 0 0px 0;margin-bottom:60px;">
  <div class="titleStyle" :style="titleStyle">
    <span style="font-size:97px;font-weight:700">{{title}}</span>
  </div>

  <div class="subTitleStyle" :style="subTitleStyle">
    <img src="@/views/solution/images/redRight.png" alt="" srcset="" style="width:23px;position:absolute;top:0;left:0">
      <img src="@/views/solution/images/shadowLogo.png" alt="" srcset="" style="width:295px;position:absolute;top:0;right:0">
      <span style="position:absolute;display:block;bottom:15px;font-size:18px;color:#51535d;letter-spacing:1px;font-weight:300">{{subTitle}}</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'App',
   components:{
 
  },
  props: {
    titleStyle: {
      type: String,
      default: ''
    },
    subTitleStyle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Solution'
    },
    subTitle: {
      type: String,
      default: '解决方案'
    }
  },
  data() {  
    return {  
     images: [  
       
      ] 
    };  
  }, 

  methods:{
    
  }
}
</script>
<style lang="scss" scoped>
.titleStyle {
  height:100%;display:inline-block;width:390px;
}
.subTitleStyle {
  position:relative;display:inline-block;width:910px;height:95px;border-bottom:1px solid #000;
}
</style>
